"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _sizeGrid = _interopRequireDefault(require("../../../../utils/sizeGrid"));

var _Storyblok = _interopRequireDefault(require("../../../../utils/Storyblok"));

var _customProps = require("../../../../utils/customProps");

var _customComponents = require("../../../../utils/customComponents");

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _fullBordered = require("@mui-treasury/styles/grid/fullBordered");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var GridItem = function GridItem(_ref) {
  var _window, _window$Storyblok;

  var components = _ref.components,
      alignContent = _ref.alignContent,
      alignItems = _ref.alignItems,
      rootClass = _ref.rootClass,
      direction = _ref.direction,
      justify = _ref.justify,
      lg = _ref.lg,
      md = _ref.md,
      sm = _ref.sm,
      wrap = _ref.wrap,
      spacing = _ref.spacing,
      xs = _ref.xs,
      xl = _ref.xl,
      content = _ref.content,
      dataBlokC = _ref.dataBlokC,
      dataBlokUid = _ref.dataBlokUid,
      storyblokClass = _ref.storyblokClass;
  var gridClass = (0, _fullBordered.useFullBorderedGridStyles)({
    borderColor: 'primary.main'
  });
  gridClass = ((_window = window) === null || _window === void 0 ? void 0 : (_window$Storyblok = _window.Storyblok) === null || _window$Storyblok === void 0 ? void 0 : _window$Storyblok.inEditor) ? gridClass : {};

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass);

  return /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    container: true,
    alignContent: alignContent,
    alignItems: alignItems,
    direction: direction,
    justify: justify,
    wrap: wrap,
    spacing: Number(spacing),
    xs: (0, _sizeGrid.default)(xs),
    sm: (0, _sizeGrid.default)(sm),
    md: (0, _sizeGrid.default)(md),
    lg: (0, _sizeGrid.default)(lg),
    xl: (0, _sizeGrid.default)(xl),
    "data-blok-c": dataBlokC,
    "data-blok-uid": dataBlokUid,
    className: "".concat(styles.root, " ").concat(storyblokClass),
    classes: gridClass
  }, !content.length && /*#__PURE__*/_react.default.createElement(_Box.default, {
    minHeight: 200,
    width: {
      xs: '100%'
    }
  }), content.length > 0 && content.map(function (component, key) {
    return /*#__PURE__*/_react.default.createElement(_react.Suspense, {
      fallback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null),
      key: key
    }, (0, _customComponents.renderComponentsWithBridge)(_objectSpread({
      TabGrid: _Grid.default
    }, components), _objectSpread(_objectSpread({}, component), {}, {
      components: components,
      key: key
    }), key));
  }));
};

var _default = GridItem;
exports.default = _default;
GridItem.propTypes = {
  /**
   * stroyblok multiselect of css classes
   * Mui Override or extend the styles applied to the component.
   */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * mui prop: 'stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around'
   * Defines the align-content style property. It's applied for all screen sizes.
   */
  alignContent: function alignContent(props, propName, componentName) {
    var validProps = ['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /**
   * mui prop: 'flex-start' , 'center' , 'flex-end' , 'stretch' , 'baseline'
   * Defines the align-items style property. It's applied for all screen sizes.
   */
  alignItems: function alignItems(props, propName, componentName) {
    var validProps = ['flex-start', 'center', 'flex-end', 'stretch', 'baseline'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /*
  * mui prop: 'row' , 'row-reverse' , 'column' , 'column-reverse'
  * Defines the flex-direction style property. It is applied for all screen sizes.
  */
  direction: function direction(props, propName, componentName) {
    var validProps = ['row', 'row-reverse', 'column', 'column-reverse'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /**
   * mui prop:
   'flex-start' , 'center' , 'flex-end' , 'space-between' , 'space-around' , 'space-evenly'
   * Defines the justify-content style property. It is applied for all screen sizes.
   */
  justify: function justify(props, propName, componentName) {
    var validProps = ['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /**
   * mui prop:
   false , 'auto' , true , 1 , 2 , 3 , 4 , 5 , 6 , 7 , 8 , 9 , 10 , 11 , 12
   * Defines the number of grids the component is going to use.
    It's applied for the breakpoint and wider screens if not overridden.
   */
  lg: function lg(props, propName, componentName) {
    return (0, _customProps.muiGridProp)(props, propName, componentName);
  },

  /**
   * mui prop: false , 'auto' , true , 1 , 2 , 3 , 4 , 5 , 6 , 7 , 8 , 9 , 10 , 11 , 12
   * Defines the number of grids the component is going to use.
   It's applied for the breakpoint and wider screens if not overridden.
   */
  md: function md(props, propName, componentName) {
    return (0, _customProps.muiGridProp)(props, propName, componentName);
  },

  /**
   * mui prop: false , 'auto' , true , 1 , 2 , 3 , 4 , 5 , 6 , 7 , 8 , 9 , 10 , 11 , 12
   * Defines the number of grids the component is going to use.
   It's applied for the breakpoint and wider screens if not overridden.
   */
  sm: function sm(props, propName, componentName) {
    return (0, _customProps.muiGridProp)(props, propName, componentName);
  },

  /**
   * mui prop:  0 , 1 , 2 , 3 , 4 , 5 , 6 , 7 , 8 , 9 , 10
   * Defines the space between the type item component.
   * It can only be used on a type container component.
   */
  // spacing: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  spacing: function spacing(props, propName, componentName) {
    var validProps = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    return (0, _customProps.muiBlokNumberProp)(props, propName, componentName, validProps);
  },

  /**
   * mui prop: 'nowrap' , 'wrap' , 'wrap-reverse'
   * Defines the flex-wrap style property. It's applied for all screen sizes.
   */
  wrap: function wrap(props, propName, componentName) {
    var validProps = ['nowrap', 'wrap', 'wrap-reverse'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /**
   * mui prop: false , 'auto' , true , 1 , 2 , 3 , 4 , 5 , 6 , 7 , 8 , 9 , 10 , 11 , 12
   * Defines the number of grids the component is going to use.
   It's applied for the breakpoint and wider screens if not overridden.
   */
  xs: function xs(props, propName, componentName) {
    return (0, _customProps.muiGridProp)(props, propName, componentName);
  },

  /**
   * mui prop: false , 'auto' , true , 1 , 2 , 3 , 4 , 5 , 6 , 7 , 8 , 9 , 10 , 11 , 12
   * Defines the number of grids the component is going to use.
   It's applied for the breakpoint and wider screens if not overridden.
   */
  xl: function xl(props, propName, componentName) {
    return (0, _customProps.muiGridProp)(props, propName, componentName);
  },

  /**
   * Content passed to from api
   * can also render any customCompnent passed in
   * will render any component in components prop
   */
  content: _propTypes.default.arrayOf(_propTypes.default.shape({
    component: _propTypes.default.string.isRequired
  })).isRequired,

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokC: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokUid: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  storyblokClass: _propTypes.default.string,

  /**  components to render in the GridItem */
  components: _propTypes.default.shape()
};
GridItem.defaultProps = {
  alignContent: 'stretch',
  alignItems: 'center',
  rootClass: [],
  direction: 'row',
  justify: 'center',
  lg: false,
  md: false,
  sm: false,
  spacing: '2',
  wrap: 'wrap',
  xl: false,
  xs: false,
  dataBlokC: '',
  dataBlokUid: '',
  storyblokClass: '',
  components: {}
};